module.exports = __webpack_public_path__ + "static/media/icon-social--insta.2858088c.svg";